import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import { changePassword } from "../../../schemas";
import { useFormik } from "formik";
import CreatableSelect from "react-select/creatable";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GET_ADMIN_SETTINGS, UPDATE_PASSWORD, ADMIN_ID } from "../../../env";
import {
    postRecords,
    getRecords,
    catchAsync,
    isSuccess,
    toastSuccessMessages,
    toastErrorMessages,
} from "../../../helper/helper";
import ProgressComponent from "../../../components/general/ProgressComponent";
import Input from "../../../components/forms-fields/Input";
import moment from "moment";
import CustomSelect from "../../../components/forms-fields/CustomSelectStaffMembers";
import UserListsPasswordChange from "./UserListsPasswordChange";

function PasswordChange({ subModalPasswordChangeModal }) {
    const handleShowHideModal = () => {
        subModalPasswordChangeModal((prevShow) => !prevShow);
    };
    const [errorMessage, setErrorMessage] = useState(false);
    const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
    const [isToastAdminSettings, setIsToastAdminSettings] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [communicationSettingDefault, setCommunicationSettingDefault] = useState("");
    const [durationHours, setDurationHours] = useState(0);
    const [durationMinutes, setDurationMinutes] = useState(0);
    const getAPIquery = {};
    const [isStaffId, setIsStaffId] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [selectedUserEmail, setSelectedUserEmail] = useState(null);
    // console.log("🚀 ~ PasswordChange ~ selectedUserEmail:", selectedUserEmail)
    // console.log("🚀 ~ PasswordChange ~ selectedUserId:", selectedUserId)
    const handleUserSelect = (userId) => {
        setSelectedUserId(userId);
        setFieldValue("userId", userId);
    };
    const handleUserEmailSelect = (userEmail) => {
        setSelectedUserEmail(userEmail)
    };
    const [suFormData, setSuFormData] = useState({
        userId: selectedUserId,
        email: selectedUserEmail,
        password: ""
    });



    const {
        values,
        errors,
        touched,
        handleSubmit,
        setFieldValue,
        handleChange,
        handleBlur,
    } = useFormik({
        initialValues: suFormData,
        validationSchema: changePassword,
        onSubmit: async (values) => {
            try {
                setIsSubmitButtonClicked(true);
                console.log("🚀 ~ Form values before submission:", values);
                await postAdminSettingsFormData(values);
            } catch (error) {
                console.error("Error in form submission:", error);
            }
        },
    });

    const processPostRecords = (method, data) => {

        if (data?.status !== isSuccess) {
            setIsToastAdminSettings(true);
            toastErrorMessages(toast.error, data?.message, "", 500, 500);
            setIsSubmitButtonClicked(false);
            handleShowHideModal();
        } else if (
            method === "postAdminSettingsFormData" &&
            data?.status === isSuccess
        ) {
            setIsToastAdminSettings(true);
            toastSuccessMessages(toast.success, data?.message, "", 500, 500);
            setIsSubmitButtonClicked(false);
            setTimeout(() => {
                handleShowHideModal();
            }, 2000);
        }
    };

    const postAdminSettingsFormData = catchAsync(async (req, res) => {
        const updateValues = {
            ...values,
            userId: selectedUserId,
            email: selectedUserEmail,
            password: values?.password
        };
        // console.log("🚀 ~ postAdminSettingsFormData ~ values:", values)
        // console.log("🚀 ~ postAdminSettingsFormData ~ updateValues:", updateValues)
        const response = await postRecords(UPDATE_PASSWORD, updateValues);
        console.log("🚀 ~ postAdminSettingsFormData ~ response:", response)
        setIsSubmitButtonClicked(false);
        processPostRecords("postAdminSettingsFormData", response);
    });


    return (
        <>
            <div className="incidents consentCapacityAddNew">
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="formBlockContent" style={{ minHeight: "180px" }}>
                        <div className="row">

                            <div className="col-md-12">
                                <div className="form-group">
                                    <UserListsPasswordChange
                                        id="userId"
                                        name="userId"
                                        onSelect={handleUserSelect}
                                        onSelectEmail={handleUserEmailSelect}
                                        filterBy={""}
                                        defaultValue={""}
                                        label={"Select Staff"}
                                        errorClass={touched.userId && errors.userId ? "validationError" : ""}
                                        customError={touched.userId && errors.userId}
                                        errorMessage={errors.userId}
                                    />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <Input
                                    type="password"
                                    id="password"
                                    name="password"
                                    autocomplete="new-password"
                                    value={values?.password}
                                    onChange={(e) => setFieldValue("password", e.target.value)}
                                    onBlur={handleBlur}
                                    labelText="Change Password"
                                    marginBottom={true}
                                    customError={touched?.password && errors?.password}
                                    errorMessage={errors?.password}
                                    erroClass={
                                        touched?.password && errors?.password
                                            ? "validationError"
                                            : ""
                                    }
                                />
                            </div>

                        </div>
                    </div>
                    <div className="formActionButtons">
                        {isSubmitButtonClicked ? (
                            <Button
                                onClick={subModalPasswordChangeModal}
                                className="btn-sm"
                                variant="primary"
                                disabled
                            >
                                Loading...
                            </Button>
                        ) : (
                            <Button className="btn-sm" variant="primary" type="submit">
                                Submit
                            </Button>
                        )}
                        <span
                            onClick={subModalPasswordChangeModal}
                            className="btn btn-sm btn-outline-primary"
                        >
                            Close
                        </span>

                    </div>
                </form>
            </div>
            {isToastAdminSettings ? <ToastContainer /> : ''}

        </>
    );
}

export default PasswordChange;